
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <letter-setting-edit *ngSwitchCase="true"></letter-setting-edit>
            <letter-setting-details *ngSwitchCase="false"></letter-setting-details>
        </div>
    </ng-template>  
</main-form-modal>